import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, orderBy, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../AuthContext';
import { getDocsByIdsChunked } from '../../utils/firestoreChunking';
import '../Dashboard.css';
import '../../components/MealTile.css';
import welcomePhoto from '../../assets/welcomePhoto.png';
import MealCardList from '../../components/MealCardList';

const Reservations = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [attendingMeals, setAttendingMeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAttendingMeals = async () => {
      if (!currentUser) return;

      try {
        const bookingsQuery = query(
          collection(db, 'bookings'),
          where('guestId', '==', currentUser.uid),
          where('status', '==', 'confirmed'),
          where('mealStatus', '==', 'active'),
          where('mealDateTime', '>=', Timestamp.now()),
          orderBy('mealDateTime', 'asc')
        );
        const bookingsSnapshot = await getDocs(bookingsQuery);
        const bookings = bookingsSnapshot.docs.map(doc => doc.data());

        const mealIds = bookings.map(booking => booking.mealId);
        if (mealIds.length === 0) {
          setAttendingMeals([]);
          setLoading(false);
          return;
        }

        // Filtering/sorting already happened server-side on the booking
        // query above; this is only a bounded display-field lookup
        // (title/photoUrl aren't denormalized onto bookings) for the
        // already-filtered set, not the old unbounded hot path.
        const mealDocs = await getDocsByIdsChunked(collection(db, 'meals'), mealIds);
        const mealsById = new Map(mealDocs.map(doc => [doc.id, doc.data()]));
        const meals = bookings
          .map(booking => mealsById.has(booking.mealId)
            ? { id: booking.mealId, ...mealsById.get(booking.mealId) }
            : null)
          .filter(Boolean);
        setAttendingMeals(meals);
      } catch (err) {
        console.error('Error fetching attending meals:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAttendingMeals();
  }, [currentUser]);

  if (!currentUser || loading) {
    return (
      <div className="dashboard-container">
        <p className="dashboard-loading">Loading...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <img
        src={welcomePhoto}
        alt="Welcome"
        className="dashboard-image"
      />

      <div className="dashboard-card">
        <div className="meals-tile">
          <h2 className="meals-tile-title">Your Reservations</h2>

          <MealCardList
            meals={attendingMeals}
            onSelect={(meal) => navigate(`/meal-summary/${meal.id}`)}
            emptyMessage="You haven't booked any meals yet."
          />
        </div>

        <button className="create-listing-button" onClick={() => navigate('/feed')}>
          Explore More
        </button>
      </div>
    </div>
  );
};

export default Reservations;
